import { useLayoutEffect, useRef } from 'react';

/* @ngInject */
export default function useRetainFocusOnToggle(expanded: boolean) {
  const triggerRef = useRef<HTMLElement | null>(null);

  function captureFocus() {
    const active = document.activeElement;
    triggerRef.current = active instanceof HTMLElement ? active : null;
  }

  useLayoutEffect(() => {
    const trigger = triggerRef.current;
    if (!trigger) return undefined;

    function tryRestoreFocus() {
      const active = document.activeElement;
      const focusLost = active === document.body || active === document.documentElement;
      if (focusLost && trigger!.isConnected) {
        trigger!.focus();
      }
    }

    tryRestoreFocus();
    const rafId = requestAnimationFrame(tryRestoreFocus);

    return () => cancelAnimationFrame(rafId);
  }, [expanded]);

  return { captureFocus };
}
